import logoWPH from "../../assets/caresLogo.png";
import logoL365 from "../../assets/Life365.svg";
import logoATM from "../../assets/ATP-horiz125h.png";

export const getLogo = () => {
  let logo;
  switch (window.location.origin) {
    case "https://wph.prd.life365inc.com":
      logo = logoWPH;
      break;
    case "https://atm.prd.life365inc.com":
      logo = logoATM;
      break;
    case "https://l365.sbx.life365inc.com":
      logo = logoL365;
      break;
    default:
      logo = logoL365;
      break;
  }
  return logo;
};
